<div class="about-section">
  <div class="container">
    <div class="row align-items-center m-1">
      <!-- Left Side: Text -->
      <div class="col-md-7 col-12 about-text">
        <h2>About Us</h2>
        <h3>Nurturing Every Child's Unique Potential</h3>
        <p>
          Innovative Vision is a pioneering company that started in 2020 with a clear dream and 
          a profound understanding of the need for an organized and structured approach to 
          imparting co-curricular skills to children. Founded on the belief that every child 
          possesses a universe of innate potential, our journey began with the inspiration to 
          provide a holistic environment where young minds can truly flourish. We are dedicated 
          to fostering a lifestyle of discipline, creativity, and joy, rather than solely 
          focusing on creating 'stars'; ensuring a balanced and enriching journey for every child.
        </p>
      </div>

      <!-- Right Side: Image -->
      <div class="col-md-5 col-12 text-center about-img">
        <img src="assets/ivimg/aboutUsGirl.svg" alt="Girl Learning Pottery" class="img-fluid">
      </div>
    </div>
  </div>
</div>

<!-- Section -->
<div class="history-section">
  <!-- Header -->
  <div class="history-header">
    <h2 style="color: #825800">Our History</h2>
    <p>A Journey of Growth</p>
  </div>
  <!-- Timeline Container -->
  <div class="history-container">
    <!-- Left Column -->
    <div class="history-column">
      <div class="history-block">
        <h3>2008: The Foundation of Strength</h3>
        <p>
          We began our mission with the implementation of Taekwondo coaching and belt 
          promotion activities. The primary purpose of this program was to equip children 
          with self-defense techniques, thereby building their confidence, focus, and inner 
          and mental strength.
        </p>
      </div>
      <div class="history-block">
        <h3>2020: The Shift to "A Way of Life"</h3>
        <p>
          The global COVID-19 pandemic reshaped our perception of life and our program's purpose. 
          We recognized the need for physical and mental strength to resist infections and cope 
          with social changes, which led us to offer online coaching and a new philosophy centered 
          on core strength as a "way of life."
        </p>
      </div>
    </div>
    <!-- Right Column -->
    <div class="history-column">
      <div class="history-block">
        <h3>2022: Expanding to the Roots of Growth</h3>
        <p>
          This year marked a significant shift as we began taking our programs directly to the 
          doorsteps of preschools. We aimed to introduce co-curricular activities at the roots 
          of growth to generate curiosity, interest, and motivation in students, with a singular 
          focus on building inner strength.
        </p>
      </div>

      <div class="history-block">
        <h3>2023: The Holistic Inflection Point</h3>
        <p>
          The year was an inflection point, leading us to expand our themes to include Fitness,
          Dance, Gymnastics, Music, Yoga, and Taekwondo. Each theme was specifically designed 
          with a "mind, body, and soul" approach to develop gross motor skills and holistic
          growth, forming the basis for a life of skill development and well-being.
        </p>
      </div>
    </div>
  </div>
</div>
<div class="holistic-section">
    <h2 style="text-align: center; color: #825800;">A Holistic Approach to Development</h2>
    <h4  style="text-align: center; color: #825800;">Empowering Mind, Body and Soul</h4>
  <div class="holistic-container">
    <!-- Left Side (Text) -->
    <div class="holistic-text">
      <p><strong>Vision -</strong> To be the leading catalyst in identifying and nurturing the innate potential of every child, fostering holistic growth and a lifelong love for learning and well-being.</p>
      <p><strong>Mission -</strong> To provide structured, organized, and empathetic co-curricular programs that empower children to develop essential life skills, enhance right-brain functions, and cultivate a balanced lifestyle, all within a safe and supportive environment.</p>
      <p><strong>Core Values -</strong> 
        <li style="font-size: 17px;">
         <b>Empathy & Nurturing:</b> Placing the child's well-being and emotional development at the forefront of every program.  
        </li>
        <li style="font-size: 17px;">
          <b>Holistic Growth:</b> Committing to the comprehensive development of mind, body, and soul.  
        </li>
        <li style="font-size: 17px;">
          <b>Discipline & Structure:</b> Implementing progressive and outcome-based curricula with periodic assessments to ensure consistent development.  
        </li>
        <li style="font-size: 17px;">
          <b>
           Innovation:  
          </b> Continuously evolving our programs and methodologies, including adopting ISO practices and exploring new avenues like nutrition.
        </li>
        <li style="font-size: 17px;">
          <b>Excellence in Mentorship:</b> Providing experienced, certified, and passionate coaches who are assets and brand ambassadors.
        </li>
      </p>
    </div>
    <!-- Right Side (Image) -->
    <div class="holistic-image">
      <img src="assets/ivimg/yogaGirl.svg" alt="Holistic Development"/>
    </div>
  </div>
</div>
<div class="vision-section">
  <!-- Header -->
  <div class="vision-header">
    <h2>Why Innovative Vision?</h2>
    <p>Beyond Skills: Our Commitment to Your Child's Complete Well-being</p>
  </div>
  <!-- Content -->
  <div class="vision-content">
    <!-- Left Column -->
    <div class="vision-text">
      <div class="vision-block">
        <h3>Unlocking Potential, Not Just Creating Stars</h3>
        <p>
          We don't promise to make your child a star, but we do promise to
          provide a nurturing space where their unique potential is identified
          and cultivated. Our focus is on building a foundation for a healthy,
          active, and joyful lifestyle.
        </p>
      </div>
      <div class="vision-block">
        <h3>Structured & Organized Learning</h3>
        <p>
          As one of the first company to identify the need for an organized
          approach to co-curricular skills, our programs are progressive,
          outcome-based, and include periodic assessments. Our certified coaches
          are passionate mentors to nurture talent.
        </p>
      </div>
    </div>
    <!-- Image -->
    <div class="vision-image">
      <img src="assets/ivimg/whyVision.svg" alt="Innovative Vision"/>
    </div>
    <!-- Right Column -->
    <div class="vision-text">
      <div class="vision-block">
        <h3>Right Brain Development for a Balanced Future</h3>
        <p>
          Our meticulously designed activity-based learning programs in sports,
          yoga, and gymnastics specifically target and enhance right-brain
          functions crucial for creativity, problem-solving, and emotional
          intelligence ensuring a truly holistic development.
        </p>
      </div>
      <div class="vision-block">
        <h3>Aligned with National Educational Policy (NEP) 2020</h3>
        <p>
          Our approach to inculcating essential skills such as gross motor
          skills, discipline, communication skills, and team spirit finds direct 
          mention and emphasis in the NEP 2020, ensuring our programs are
          contemporary and impactful.
        </p>
      </div>
    </div>
  </div>
</div>
<div class="team-section">
  <div class="team-header">
    <h2>Our Team</h2>
    <p>The Directors</p>
  </div>
  <div class="team-grid">
  <!-- Card 1 -->
  <div class="team-card">
    <img src="assets/ivimg/team1.svg" alt="Director 1"/>
    <h3 style="text-align: center;">Ghansham F. Dhongade</h3>
    <h4 style="text-align: center;font-style: italic;font-weight: 400;">(Founder & Curriculum Developer)</h4>
    <p style="text-align: justify;">
      A sports professional with 20 years of experience in physical education and sports
      development, with coaching, training program design, and student engagement as part of life.
      Proven record of building grassroots programs, mentoring athletes and collaborating with
      preschools, schools and institutions.
    </p>
    <!-- <h4 style="text-align: center;">Qualification:</h4>
    <p style="text-align: center;font-style: italic;font-weight: 400;">M.A, M.P.Ed (Physical Education), MBA (Management), MSW (Social Work)</p> -->
  </div>

  <!-- Card 2 -->
  <div class="team-card">
    <img src="assets/ivimg/team2.svg" alt="Director 2"/>
    <h3 style="text-align: center;">Amrish Kshatriya,</h3>
    <h4 style="text-align: center;font-style: italic;font-weight: 400;">(Co-Founder & Business Head)</h4>
    <p style="text-align: justify;">
      20 plus years of experience in corporate account management practiced in transforming customers to partners. Efficient in consultative selling and in translating technical solution to business opportunities. Brief experience in making content and branding, an avid reader and learner.
    </p>
    <!-- <h4 style="text-align: center;">Qualification:</h4>
    <p style="text-align: center;font-style: italic;font-weight: 400;">B.E, MBA </p> -->
  </div>
  <!-- Card 3 -->
  <div class="team-card">
    <img src="assets/ivimg/team3.svg" alt="Director 3"/>
    <h3 style="text-align: center;">Sanjeet F. Dhongade,</h3>
    <h4 style="text-align: center;font-style: italic;font-weight: 400;">(Director)</h4>
    <p style="text-align: justify;">
      20 plus years of experience with sports equipment industry, with deep understanding of wholesale, distribution and strategic partnership. He has worked in domains of procurement, supply chain management, dealer networking and retail collaborations.
    </p>
    <!-- <h4 style="text-align: center;">Qualification:</h4>
    <p style="text-align: center;font-style: italic;font-weight: 400;">B. Com(Account)</p> -->
  </div>
</div>
</div>
<app-founder-msg></app-founder-msg>
